module.exports = {"name":"Esther Peachey Lefevre Park","description":"Esther Peachey Lefevre Park is a small corner park in Cabbagetown. The park has a relatively new playground, bike racks, and a dog hitching post.","parking":"There is street parking along Powell St.","hours":"7am - 11pm","location":"https://www.google.com/maps/place/Esther+Peachey+Lefevre+Park/@33.7513283,-84.3663961,19.28z","moreInfo":"","tags":["playground"]}


//////////////////
// WEBPACK FOOTER
// ./src/data/esther-peachey-lefevre.json
// module id = ./src/data/esther-peachey-lefevre.json
// module chunks = main